// Форматирование и справочники вкладки «Цены» площадок.

export const PLATFORM_LABELS = { prom: "Prom", rozetka: "Rozetka", kasta: "Kasta" };

export const RULE_MODE_LABELS = {
    rrp_discount_percent: "Скидка от РРЦ, %",
    profit_uah: "Своя прибыль, грн",
    fixed_price: "Фиксированная цена, грн",
    price_discount_percent: "Скидка от расчётной цены, %",
};

export const RULE_MODE_UNITS = {
    rrp_discount_percent: "%",
    profit_uah: "грн",
    fixed_price: "грн",
    price_discount_percent: "%",
};

export const RULE_STATUS_LABELS = {
    active: "Действует",
    scheduled: "Запланировано",
    expired: "Истекло",
    inactive: "Выключено",
};

export const SKIP_REASON_LABELS = {
    below_breakeven: "ниже безубыточности",
    rrp_supplier: "у поставщика РРЦ",
    dumping_mode: "включён демпинг",
    rrp_missing: "нет РРЦ",
    rule_price_zero: "цена правила 0",
};

export const money = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    const number = Number(value);
    if (Number.isNaN(number)) return String(value);
    return number.toLocaleString("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const pct = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    const number = Number(value);
    if (Number.isNaN(number)) return String(value);
    return `${number.toLocaleString("uk-UA", { maximumFractionDigits: 3 })} %`;
};

const toNumber = (value) => {
    if (value === null || value === undefined) return 0;
    const number = Number(String(value).replace(",", "."));
    return Number.isFinite(number) ? number : NaN;
};

export const parseDecimalInput = toNumber;

// FastAPI 422 приходит списком detail[{loc, msg}] — показываем коротко и по-человечески.
export const formatApiError = (error, fallback = "Не удалось выполнить запрос.") => {
    const detail = error?.response?.data?.detail;
    if (!detail) return error?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
                const loc = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== "body").join(".") : "";
                const msg = String(item?.msg || "").replace(/^Value error, /, "");
                return loc ? `${loc}: ${msg}` : msg;
            })
            .filter(Boolean)
            .join(" | ") || fallback;
    }
    if (typeof detail === "object") return detail.message || fallback;
    return fallback;
};

// Пример расчёта из черновика формы: закупка → нужно получить → цена.
export const previewFormula = (draft, cost = 100) => {
    const percents = ["commission_percent", "payment_percent", "other_percent"].map((key) => toNumber(draft[key]));
    const total = percents.reduce((sum, value) => sum + value, 0);
    const fixed = toNumber(draft.fixed_uah_per_item);
    const profit = toNumber(draft.default_supplier_profit_uah);
    if ([total, fixed, profit].some(Number.isNaN) || total >= 100) {
        return null;
    }
    const share = 1 - total / 100;
    const breakeven = (cost + fixed) / share;
    const required = cost + fixed + profit;
    return {
        cost,
        totalPercent: total,
        required,
        breakeven: Math.round(breakeven * 100) / 100,
        price: Math.round((required / share) * 100) / 100,
    };
};

export const splitCodes = (text) => [...new Set(String(text || "").split(/[\s,;]+/).map((code) => code.trim()).filter(Boolean))];
